import { render, staticRenderFns } from "./ViewerImage.vue?vue&type=template&id=64c7513a&"
import script from "./ViewerImage.vue?vue&type=script&lang=js&"
export * from "./ViewerImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports